import { render } from "./CategoryItem.vue?vue&type=template&id=c4274278&scoped=true&ts=true"
import script from "./CategoryItem.vue?vue&type=script&lang=ts"
export * from "./CategoryItem.vue?vue&type=script&lang=ts"

import "./CategoryItem.vue?vue&type=style&index=0&id=c4274278&scoped=true&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4274278"]])

export default __exports__